module.exports = __webpack_public_path__ + "img/3ab63b6.png";